import React from 'react';
import { Link, LinkProps } from '@cp/ds/src/components/link';
import { useStartBillingSubscription } from '../model';

export const StartSubscriptionLink = (props: LinkProps) => {
  const [startSubscription] = useStartBillingSubscription();
  return <Link onClick={startSubscription} {...props} />;
};
